import { SessionHub } from '@addmile/backend-client';

import { useCoachSessionsTableData } from './Filters/useCoachSessionTableData';
import { useSessionsTableData } from './Filters/useSessionTableData';

export const useSessionTableHandler = (sessions: SessionHub[], isCoachView: boolean = false) => {
  const coachData = useCoachSessionsTableData(sessions);
  const userData = useSessionsTableData(sessions);

  return isCoachView ? coachData : userData;
};
